module.exports = __webpack_public_path__ + "img/banner_aug_18.b99faffa.png";